module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-7d29b877.png";